import { LocationState } from '@eventbrite/discover-utils';
import { gettext } from '@eventbrite/i18n';
import { OrganicEventSearchApiPayload } from '@eventbrite/search-utils';
import { getPlaceFromCoordinates } from '@eventbrite/user-location';
import { DEFAULT_DESTINATION_EVENT_EXPANSIONS } from '../../../../constants';

export interface DeviceLocationState extends LocationState {
    radius?: string;
}

export const getQuery = (
    location: DeviceLocationState,
): OrganicEventSearchApiPayload => {
    return {
        browse_surface: 'homepage',
        event_search: {
            page_size: 8,
            dates: ['current_future'],
            point_radius: {
                radius: location.radius ?? '50mi',
                latitude: location.latitude,
                longitude: location.longitude,
            },
            online_events_only: false,
            image: true,
            available: true,
            sold_out_status: true,
            places: location.placeId ? [location.placeId] : [],
        },
        'expand.destination_event': DEFAULT_DESTINATION_EVENT_EXPANSIONS,
    };
};

export const getLocation = (setDeviceLocation: any, location: any) => {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const { latitude, longitude } = position.coords;
                const place = await getPlaceFromCoordinates({
                    latitude,
                    longitude,
                });
                setDeviceLocation({
                    ...place,
                    currentPlace: place?.name,
                    placeId: place?.id,
                    radius: '5mi',
                });
            },
            (err: any) => {
                console.log(err?.message);
                setDeviceLocation(location);
            },
        );
    } else {
        console.log('geolocation not supported: ');
        setDeviceLocation(location);
    }
};

export const getTitle = (
    locationCurrentPlace: string,
    deviceCurrentPlace: string,
) => {
    if (locationCurrentPlace == deviceCurrentPlace)
        return gettext('Trending in %(currentPlace)s', {
            currentPlace: deviceCurrentPlace,
        });
    else return gettext('Trending near you');
};
